/** Types du domaine MovMania. Aucune dépendance framework ici. */

export type Locale = 'fr' | 'en'

/**
 * Familles d'activité proposées à la saisie manuelle et remontées
 * par Apple Santé / Health Connect (après normalisation).
 */
export type ActivityType =
  | 'walk'
  | 'run'
  | 'bike'
  | 'swim'
  | 'strength'
  | 'yoga'
  | 'sport'
  | 'other'

export const ACTIVITY_TYPES: readonly ActivityType[] = [
  'walk',
  'run',
  'bike',
  'swim',
  'strength',
  'yoga',
  'sport',
  'other',
] as const

/** D'où vient la donnée. Le domaine ne fait aucune différence de traitement. */
export type ActivitySource = 'manual' | 'healthkit' | 'health_connect'

export interface Activity {
  id: string
  type: ActivityType
  /** ISO 8601, heure locale de l'utilisateur */
  startedAt: string
  durationMin: number
  source: ActivitySource
  /** Estimation, jamais une mesure médicale */
  kcal?: number
  note?: string
}

/** Intensité au sens des équivalents métaboliques (MET). */
export type Intensity = 'light' | 'moderate' | 'vigorous'

/**
 * Pratique déclarée à l'inscription. Sert à proposer un premier objectif
 * atteignable : annoncer 150 min à quelqu'un de sédentaire le fait fuir.
 */
export type CurrentPractice = 'none' | 'occasional' | 'regular' | 'frequent'

export const CURRENT_PRACTICES: readonly CurrentPractice[] = [
  'none',
  'occasional',
  'regular',
  'frequent',
] as const

/**
 * Objectif principal déclaré. Reprend les intentions du cahier des charges.
 * Il oriente le ton des encouragements — il ne déclenche AUCUN programme
 * personnalisé ni conseil médical.
 */
export type PrimaryGoal =
  | 'weight'
  | 'fitness'
  | 'mobility'
  | 'enjoyment'
  | 'endurance'
  | 'habit'
  | 'event'

export const PRIMARY_GOALS: readonly PrimaryGoal[] = [
  'fitness',
  'habit',
  'enjoyment',
  'endurance',
  'mobility',
  'weight',
  'event',
] as const

export interface UserProfile {
  id: string
  displayName: string
  locale: Locale
  /** Objectif hebdomadaire personnel, en minutes d'activité */
  weeklyGoalMin: number
  favoriteActivities: ActivityType[]
  currentPractice: CurrentPractice
  primaryGoal: PrimaryGoal
  /** Facultatifs : servent uniquement à affiner l'estimation des kcal. */
  birthYear?: number
  heightCm?: number
  weightKg?: number
  createdAt: string
}

/** Âge révolu, ou undefined si l'année de naissance n'a pas été renseignée. */
export function ageFromProfile(profile: UserProfile, now = new Date()): number | undefined {
  if (!profile.birthYear) return undefined
  return now.getFullYear() - profile.birthYear
}
